import React from 'react';
import PropTypes from 'prop-types';
import { User } from 'lucide-react';
import styles from './ProfileHeaderPreview.module.scss';

function resolveAvatarUrl(avatars) {
  if (!avatars || avatars.placeholder) {
    return null;
  }
  if (avatars.temp) {
    return avatars.temp;
  }
  const images = avatars.images || {};
  const size =
    images['190'] || images['140'] || images['110'] || images['70'] || null;
  if (size && size.square && size.square.main) {
    return size.square.main;
  }
  return null;
}

/**
 * Scaled mock of the portfolio header cover — avatar top-left, then name and
 * roles stacked below (matching PortfolioHeader layout, not a side-by-side row).
 */
const ProfileHeaderPreview = ({
  coverUrl,
  coverCss,
  avatars,
  displayName,
  roleLabel,
  showEyebrow,
}) => {
  const avatarUrl = resolveAvatarUrl(avatars);

  return (
    <div>
      {showEyebrow ? (
        <p className={styles.eyebrow}>Preview — your profile header</p>
      ) : null}
      <div className={styles.preview} aria-hidden="true">
        <div
          className={styles.cover}
          style={
            coverUrl
              ? { backgroundImage: `url(${coverUrl})` }
              : { background: coverCss || '#1a1f26' }
          }
        />
        <div className={styles.scrim} />
        <div className={styles.content}>
          <div className={styles.avatar}>
            {avatarUrl ? (
              <img src={avatarUrl} alt="" />
            ) : (
              <div className={styles.avatarDefault}>
                <User size={28} strokeWidth={1.5} />
              </div>
            )}
          </div>
          <div className={styles.meta}>
            <p className={styles.name}>{displayName || 'Your name'}</p>
            <p className={styles.role}>{roleLabel || 'Your roles'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

ProfileHeaderPreview.propTypes = {
  coverUrl: PropTypes.string,
  coverCss: PropTypes.string,
  avatars: PropTypes.object,
  displayName: PropTypes.string,
  roleLabel: PropTypes.string,
  showEyebrow: PropTypes.bool,
};

ProfileHeaderPreview.defaultProps = {
  coverUrl: null,
  coverCss: null,
  avatars: null,
  displayName: '',
  roleLabel: '',
  showEyebrow: true,
};

export default ProfileHeaderPreview;
